import React from "react";
import Reveal from "./Reveal";
import { Umbrella, UtensilsCrossed, Plane, Building2 } from "lucide-react";
import { SERVICES } from "../mock";

const ICONS = {
  umbrella: Umbrella,
  "utensils-crossed": UtensilsCrossed,
  plane: Plane,
  "building-2": Building2,
};

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#FAF8F3] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="max-w-2xl">
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Exclusive Services
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            A concierge for <span className="gold-text italic">every hour</span> of
            your stay
          </h2>
        </Reveal>
        <div className="grid lg:grid-cols-12 gap-6 mt-16">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal
                key={s.title}
                delay={i * 0.08}
                className={`group ${s.span === 7 ? "lg:col-span-7" : "lg:col-span-5"}`}
              >
                <div className="relative h-full min-h-[340px] overflow-hidden border border-[#B88A3B]/30">
                  <img
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    src={s.image}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B284A]/90 via-[#0B284A]/35 to-transparent" />
                  <div className="relative z-10 flex flex-col justify-end h-full p-8 lg:p-10">
                    <Icon size={30} strokeWidth={1.2} className="text-[#C09245] mb-5" />
                    <h3 className="font-serif-lux text-2xl md:text-3xl font-medium tracking-tight mb-4 text-[#FAF8F3]">
                      {s.title}
                    </h3>
                    <ul className="space-y-2">
                      {s.items.map((it) => (
                        <li
                          key={it}
                          className="text-sm text-[#F9F9F7]/70 flex items-start gap-3"
                        >
                          <span className="w-1 h-1 rotate-45 bg-[#B88A3B] mt-2 shrink-0" />
                          {it}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
